import { withSvgIcon } from './withSvgIcon';

export const More = withSvgIcon(
  <>
    <circle cx="4" cy="12" r="2" fill="currentColor" />
    <circle cx="12" cy="12" r="2" fill="currentColor" />
    <circle cx="20" cy="12" r="2" fill="currentColor" />
  </>,
  { viewBox: '0 0 24 24' },
);
